<form class="form" id="editContactForm" (ngSubmit)="onSubmit()" #contactForm="ngForm">

        <!-- Ticket holder -->
        <div *ngIf="this.callFromAddInvitee" class="form-group row align-items-center mt-2 mb-4">
            <div class="col-3 col-lg-2">
                <label>{{ 'INPUT.TICKETHOLDER.UNALLOCATED.LABEL' | translate }}</label>
                <i class="fa fa-question-circle help-icon ml-1" [title]="'INPUT.TICKETHOLDER.UNALLOCATED.HELP' | translate"></i>
            </div>
            <div class="col-5">
                <div class="input-group with-focus">
                    <ngx-select
                        class="form-control select-control"
                        [allowClear]="true"
                        [items]="ticketHoldersForDropdown"
                        [(ngModel)]="ticketHolder"
                        #ticketHolderId="ngModel"
                        name="ticketHolderId"
                        required
                        [placeholder]="'INPUT.TICKETHOLDER.TICKETHOLDER.PLACEHOLDER' | translate">
                    </ngx-select>
                </div>
                <div *ngIf="ticketHolderId.invalid && (ticketHolderId.dirty || ticketHolderId.touched)" class="text-danger">
                    <div *ngIf="ticketHolderId.errors.required">
                        {{ 'INPUT.TICKETHOLDER.VALIDATION.REQUIRED' | translate }}
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="this.callFromAddInvitee" class="form-group row align-items-center mt-2 mb-4">
            <div class="col-3 col-lg-2">
                <label>{{ 'ROUTES.EVENTDETAIL.COMPONENTS.INVITATIONLIST.LINKEDGROUPS.HEADER' | translate }}</label>
            </div>
            <div class="col-5">
                <div class="input-group with-focus">
                    <ngx-select
                        class="form-control select-control"
                        [allowClear]="false"
                        [items]="groupsForDropdown"
                        [(ngModel)]="model.groupIds"
                        #ticketHolderId="ngModel"
                        name="groupIds"
                        [multiple]="true"
                        [placeholder]="'INPUT.SELECTGROUPS.PLACEHOLDER' | translate">
                    </ngx-select>
                </div>
                <div *ngIf="ticketHolderId.invalid && (ticketHolderId.dirty || ticketHolderId.touched)" class="text-danger">
                    <div *ngIf="ticketHolderId.errors.required">
                        {{ 'INPUT.TICKETHOLDER.VALIDATION.REQUIRED' | translate }}
                    </div>
                </div>
            </div>
        </div>
    <tabset [justified]="true" class="mt-2">
        <!-- Contact details -->
        <tab [heading]="'ROUTES.ADDRESSBOOK.MYCONTACTS.CONTACT.DETAILS.TITLE' | translate">
            <div class="row mt-4">
                <div class="col-lg-6">
                    <div class="row">
                        <div class="col-12 mb-2">
                            <div class="form-group row align-items-center">
                                <div class="col-3">
                                    <label>{{ 'INPUT.FIRSTNAME.LABEL' | translate }} *</label>
                                </div>
                                <div class="col-8">
                                    <div class="input-group with-focus">
                                        <input class="form-control" type="text" [placeholder]="'INPUT.FIRSTNAME.PLACEHOLDER' | translate" [disabled]="!canEdit && isEdit" required [(ngModel)]="model.firstName" name="firstName" #firstName="ngModel"/>
                                    </div>
                                    <div *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)" class="text-danger">
                                        <div *ngIf="firstName.errors.required">
                                            {{ 'INPUT.FIRSTNAME.VALIDATION.REQUIRED' | translate }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mb-2" *ngIf="tenantSettings?.lastNamePrefixPermission">
                            <div class="form-group row align-items-center">
                                <div class="col-3">
                                    <label>{{ 'INPUT.LASTNAMEPRE.LABEL' | translate }}</label>
                                </div>
                                <div class="col-8">
                                    <div class="input-group with-focus">
                                        <input class="form-control" type="text" [placeholder]="'INPUT.LASTNAMEPRE.PLACEHOLDER' | translate" [disabled]="!canEdit && isEdit" [(ngModel)]="model.lastNamePrefix" name="lastNamePrefix"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mb-2">
                            <div class="form-group row align-items-center">
                                <div class="col-3">
                                    <label>{{ 'INPUT.LASTNAME.LABEL' | translate }} *</label>
                                </div>
                                <div class="col-8">
                                    <div class="input-group with-focus">
                                        <input class="form-control" type="text" [placeholder]="'INPUT.LASTNAME.PLACEHOLDER' | translate" [disabled]="!canEdit && isEdit" required [(ngModel)]="model.lastName" name="lastName" #lastName="ngModel"/>
                                    </div>
                                    <div *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)" class="text-danger">
                                        <div *ngIf="lastName.errors.required">
                                            {{ 'INPUT.LASTNAME.VALIDATION.REQUIRED' | translate }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="row">
                        <div class="col-12 mb-2">
                            <div class="form-group row align-items-center">
                                <div class="col-3">
                                    <label>{{ 'INPUT.EMAIL.LABEL' | translate }} *</label>
                                </div>
                                <div class="col-8">
                                    <div class="input-group with-focus">
                                        <input class="form-control" type="email" [placeholder]="'INPUT.EMAIL.PLACEHOLDER' | translate" [disabled]="!canEdit && isEdit" required ngvemail [(ngModel)]="model.email" name="email" #email="ngModel"/>
                                    </div>
                                    <div *ngIf="email.invalid && (email.dirty || email.touched)" class="text-danger">
                                        <div *ngIf="email.errors.required">
                                            {{ 'INPUT.EMAIL.VALIDATION.REQUIRED' | translate }}
                                        </div>
                                        <div *ngIf="!email.errors.required && email.errors.email">
                                            {{ 'INPUT.EMAIL.VALIDATION.INVALID' | translate }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mb-2">
                            <div class="form-group row align-items-center">
                                <div class="col-3">
                                    <label>{{ 'INPUT.MOBILE.LABEL' | translate }}</label>
                                </div>
                                <div class="col-8">
                                    <div class="input-group with-focus">
                                        <input class="form-control" type="text" [placeholder]="'INPUT.MOBILE.PLACEHOLDER' | translate" [(ngModel)]="model.mobile" name="mobile" #mobile="ngModel" pattern="^\+(\d){11,}" />
                                    </div>
                                    <div *ngIf="mobile.invalid" class="text-danger">
                                        <div *ngIf="mobile.errors.pattern">
                                            {{ 'INPUT.MOBILE.VALIDATION.INVALID' | translate }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mb-2">
                            <div class="form-group row align-items-center">
                                <div class="col-3">
                                    <label>{{ 'INPUT.PHONE.LABEL' | translate }}</label>
                                </div>
                                <div class="col-8">
                                    <div class="input-group with-focus">
                                        <input class="form-control" type="text" [placeholder]="'INPUT.PHONE.PLACEHOLDER' | translate" [(ngModel)]="model.phone" name="phone" #phone="ngModel" pattern="^\+(\d){10,}" />
                                    </div>
                                    <div *ngIf="phone.invalid" class="text-danger">
                                        <div *ngIf="phone.errors.pattern">
                                            {{ 'INPUT.PHONE.VALIDATION.INVALID' | translate }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-2">
                    <div class="form-group row align-items-center">
                        <div class="col-3">
                            <label>{{ 'INPUT.JOBTITLE.LABEL' | translate }}</label>
                        </div>
                        <div class="col-8">
                            <div class="input-group with-focus">
                                <input class="form-control" type="text" [placeholder]="'INPUT.JOBTITLE.PLACEHOLDER' | translate" [(ngModel)]="model.title" name="title" #title="ngModel"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-2">
                    <div class="form-group row align-items-center">
                        <div class="col-3">
                            <label>{{ 'INPUT.COMPANY.LABEL' | translate }}</label>
                        </div>
                        <div class="col-8">
                            <div class="input-group with-focus">
                                <input class="form-control" type="text" [placeholder]="'INPUT.COMPANY.PLACEHOLDER' | translate" [(ngModel)]="model.companyName" name="companyName" #companyName="ngModel"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-2">
                    <div class="form-group row align-items-center">
                        <div class="col-3">
                            <label>{{ 'INPUT.OWNER.LABEL' | translate }}</label>
                        </div>
                        <div class="col-8">
                            <div class="input-group with-focus">
                                <ngx-select class="form-control select-control" [allowClear]="true" [items]="usersForDropdown" [(ngModel)]="model.accountOwnerId" #accountOwnerId="ngModel" name="accountOwnerId" [placeholder]="'INPUT.OWNER.PLACEHOLDER' | translate">
                                </ngx-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-2">
                    <div class="form-group row align-items-center">
                        <div class="col-3">
                            <label>{{ 'INPUT.LANGUAGE.LABEL' | translate }} *</label>
                        </div>
                        <div class="col-8">
                            <div class="input-group with-focus">
                                <ngx-select class="form-control select-control" [allowClear]="false" [items]="itemsLanguage" [disabled]="!canEdit && isEdit" [(ngModel)]="model.languageId" #languageId="ngModel" name="languageId" required [placeholder]="'INPUT.LANGUAGE.PLACEHOLDER' | translate">
                                </ngx-select>
                            </div>
                            <div *ngIf="languageId.invalid && (languageId.dirty || languageId.touched)" class="text-danger">
                                <div *ngIf="languageId.errors.required">
                                    {{ 'INPUT.LANGUAGE.VALIDATION.REQUIRED' | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-2">
                    <div class="form-group row align-items-center">
                        <div class="col-3">
                            <label>{{ 'INPUT.CONTACTTYPE.LABEL' | translate }} *</label>
                        </div>
                        <div class="col-8">
                            <div class="input-group with-focus">
                                <ngx-select class="form-control select-control" [items]="itemsContactType" [disabled]="!canEdit && isEdit" [(ngModel)]="model.type" #type="ngModel" name="type" required [placeholder]="'INPUT.CONTACTTYPE.PLACEHOLDER' | translate">
                                </ngx-select>
                            </div>
                            <div *ngIf="type.invalid && (type.dirty || type.touched)" class="text-danger">
                                <div *ngIf="type.errors.required">
                                    {{ 'INPUT.CONTACTTYPE.VALIDATION.REQUIRED' | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-2">
                    <div class="form-group row align-items-center">
                        <div class="col-3">
                            <label>{{ 'INPUT.GENDER.LABEL' | translate }}</label>
                        </div>
                        <div class="col-8">
                            <div class="input-group with-focus">
                                <ngx-select class="form-control select-control" [items]="itemsGender" [(ngModel)]="model.genderId" #genderId="ngModel" name="genderId" [placeholder]="'INPUT.GENDER.PLACEHOLDER' | translate">
                                </ngx-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-2">
                    <div class="form-group row align-items-center">
                        <div class="col-3">
                            <label>{{ 'INPUT.SALUTATION.LABEL' | translate }}</label>
                        </div>
                        <div class="col-8">
                            <div class="input-group with-focus">
                                <input class="form-control" type="text" [placeholder]="'INPUT.SALUTATION.PLACEHOLDER' | translate" [(ngModel)]="model.salutation" name="salutation" #salutation="ngModel"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-2">
                    <div class="form-group row align-items-center">
                        <div class="col-3">
                            <label>{{ 'INPUT.CRMID.LABEL' | translate }}</label>
                        </div>
                        <div class="col-8">
                            <div class="input-group with-focus">
                                <input class="form-control" type="text" [placeholder]="'INPUT.CRMID.PLACEHOLDER' | translate" [(ngModel)]="model.crmId" name="crmId" #crmId="ngModel"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-2">
                    <div class="form-group row align-items-center">
                        <div class="col-3">
                            <label>{{ 'INPUT.CUSTOMERNUMBER.LABEL' | translate }}</label>
                        </div>
                        <div class="col-8">
                            <div class="input-group with-focus">
                                <input class="form-control" type="text" [placeholder]="'INPUT.CUSTOMERNUMBER.PLACEHOLDER' | translate" [(ngModel)]="model.customerNumber" name="customerNumber" #customerNumber="ngModel"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-2">
                    <div class="form-group row align-items-center">
                        <div class="col-3">
                            <label>{{ 'INPUT.ACCESSCODE.LABEL' | translate }}</label>
                        </div>
                        <div class="col-8">
                            <div class="input-group with-focus">
                                <input
                                    class="form-control"
                                    type="text"
                                    [placeholder]="'INPUT.ACCESSCODE.PLACEHOLDER' | translate"
                                    [(ngModel)]="model.accessCode"
                                    name="accessCode"
                                    #accessCode="ngModel"
                                    [required]="canEdit"
                                    minlength="6"
                                    maxlength="20"
                                    pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*"/>
                            </div>
                            <div *ngIf="accessCode.invalid && (accessCode.dirty || accessCode.touched)" class="text-danger">
                                <div *ngIf="accessCode.errors.required">
                                    {{ 'INPUT.ACCESSCODE.VALIDATION.REQUIRED' | translate }}
                                </div>
                                <div *ngIf="accessCode.errors.minlength">
                                    {{ 'INPUT.ACCESSCODE.VALIDATION.MINLENGTH' | translate }}
                                </div>
                                <div *ngIf="accessCode.errors.pattern">
                                    {{ 'INPUT.ACCESSCODE.VALIDATION.PATTERN' | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </tab>
        <!-- Address details -->
        <tab [heading]="'ROUTES.ADDRESSBOOK.MYCONTACTS.CONTACT.ADDRESS.TITLE' | translate">
            <div class="row mt-4">
                <div class="col-lg-6">
                    <div class="form-group row align-items-center">
                        <div class="col-3">
                            <label>{{ 'INPUT.ADDRESS.STREET.LABEL' | translate }}</label>
                        </div>
                        <div class="col-8">
                            <input class="form-control" type="text" [placeholder]="'INPUT.ADDRESS.ADDRESSLINEONE.PLACEHOLDER' | translate" [(ngModel)]="model.addressLineOne" name="addressLineOne" #addressLineOne="ngModel" />
                        </div>
                    </div>
                    <div class="form-group row align-items-center">
                        <div class="col-3">
                            <label>&nbsp;</label>
                        </div>
                        <div class="col-8">
                            <input class="form-control" type="text" [placeholder]="'INPUT.ADDRESS.ADDRESSLINETWO.PLACEHOLDER' | translate" [(ngModel)]="model.addressLineTwo" name="addressLineTwo" #addressLineTwo="ngModel" />
                        </div>
                    </div>
                    <div class="form-group row align-items-center">
                        <div class="col-3">
                            <label>{{ 'INPUT.ADDRESS.COUNTRY.LABEL' | translate }}</label>
                        </div>
                        <div class="col-8">
                            <ngx-select
                                [allowClear]="true"
                                [items]="itemsCountries"
                                [(ngModel)]="model.country" name="country" #country="ngModel"
                                [placeholder]="'INPUT.ADDRESS.COUNTRY.PLACEHOLDER' | translate">
                            </ngx-select>
                            <!-- <input class="form-control" type="text" [placeholder]="'INPUT.ADDRESS.COUNTRY.PLACEHOLDER' | translate" [(ngModel)]="model.country" name="country" #country="ngModel" /> -->
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group row align-items-center">
                        <div class="col-3">
                            <label>{{ 'INPUT.ADDRESS.ZIP.LABEL' | translate }}</label>
                        </div>
                        <div class="col-8">
                            <input class="form-control" type="text" [placeholder]="'INPUT.ADDRESS.ZIP.PLACEHOLDER' | translate" [(ngModel)]="model.postalCode" name="postalCode" #postalCode="ngModel" />
                        </div>
                    </div>
                    <div class="form-group row align-items-center">
                        <div class="col-3">
                            <label>{{ 'INPUT.ADDRESS.CITY.LABEL' | translate }}</label>
                        </div>
                        <div class="col-8">
                            <input class="form-control" type="text" [placeholder]="'INPUT.ADDRESS.CITY.PLACEHOLDER' | translate" [(ngModel)]="model.city" name="city" #city="ngModel" />
                        </div>
                    </div>
                </div>
            </div>
        </tab>
            <!-- Permissions -->
            <tab *ngIf="!this.callFromAddInvitee" [heading]="'ROUTES.ADDRESSBOOK.MYCONTACTS.CONTACT.PERMISSIONS.TITLE' | translate">
                <div class="row mt-4">
                    <!-- Settings -->
                    <div *ngIf="canEdit" class="col-12 mb-1">
                        <h5>{{ 'ROUTES.ADDRESSBOOK.MYCONTACTS.CONTACT.PERMISSIONS.SETTINGS.TITLE' | translate }}</h5>
                        <hr />
                    </div>
                    <div class="col-12">
                        <div class="row">
                            <!-- Unsubscribe permissions -->
                            <!-- Contains always at least 2 permissions, namely the default event and campaign type -->
                            <div *ngFor="let unsubscribeOption of unsubscribeOptions" class="col-12 col-md-6 col-lg-3 mt-2 form-group d-flex align-items-center">
                                <label class="switch">
                                    <!-- Default event type is mailing permission -->
                                    <input
                                        *ngIf="unsubscribeOption?.unsubscribeOptionType === 1 && unsubscribeOption?.isDefault"
                                        class="form-control"
                                        type="checkbox"
                                        name="mailPermission"
                                        [(ngModel)]="model.mailPermission"
                                        #mailPermission="ngModel" />
                                    <!-- Dynamic unsubscribe permissions of campaign type -->
                                    <input
                                        *ngIf="unsubscribeOption?.unsubscribeOptionType === 2"
                                        class="form-control"
                                        type="checkbox"
                                        [(ngModel)]="unsubscribeOption.isChecked"
                                        [ngModelOptions]="{standalone: true}"
                                        id="{{unsubscribeOption.id}}"
                                        name="{{unsubscribeOption.id}}" />
                                    <span></span>
                                </label>
                                <label class="ml-3">{{ unsubscribeOption?.name }}</label>
                            </div>
                            <!-- Fixed SMS permission -->
                            <div class="col mt-2 form-group d-flex align-items-center">
                                <label class="switch">
                                    <input class="form-control" type="checkbox" name="smsPermission" [(ngModel)]="model.smsPermission" #smsPermission="ngModel" />
                                    <span></span>
                                </label>
                                <label class="ml-3">{{ 'INPUT.SMSPERMISSION.LABEL' | translate }}</label>
                            </div>
                        </div>
                    </div>
                    <!-- Last modified -->
                    <div *ngIf="canEdit" class="col-12 mt-4">
                        <h5>{{ 'ROUTES.ADDRESSBOOK.MYCONTACTS.CONTACT.PERMISSIONS.LOG.TITLE' | translate }}</h5>
                        <hr />
                    </div>
                    <div class="col-12 mb-2">
                        <ngx-datatable
                            #tableLog
                            class="material striped"
                            [columnMode]="'force'"
                            [headerHeight]="'auto'"
                            [footerHeight]="'auto'"
                            [rowHeight]="'auto'"
                            [rows]="model?.logs"
                            [limit]="8"
                            [messages]="{emptyMessage: 'DATATABLE.EMPTYMESSAGE.LOG.TITLE' | translate}"
                            >
                            <ngx-datatable-column name="unsubscribeOption">
                                <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
                                    <span [innerHtml]="'DATATABLE.COLUMN.UNSUBSCRIBE.NAME.TITLE' | translate" (click)="sort()"></span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <span>
                                        {{ row?.unsubscribeOption?.name }}
                                    </span>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="actionBy">
                                <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
                                    <span [innerHtml]="'DATATABLE.COLUMN.UNSUBSCRIBE.ACTIONBYTYPE.TITLE' | translate" (click)="sort()"></span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <span>
                                        {{ 'CONTACTACTIONBYTYPE.' + row?.actionByType | translate }}
                                        <ng-container *ngIf="row?.actionByType === 1 || row?.actionByType === 4">
                                            ({{ row?.user?.firstName + ' ' + row?.user?.lastName }})
                                        </ng-container>
                                        <ng-container *ngIf="row?.actionByType === 2">
                                            ({{ model?.firstName }}{{ tenantSettings?.lastNamePrefixPermission && model?.lastNamePrefix ? ' ' + model?.lastNamePrefix : '' }} {{ model?.lastName }})
                                        </ng-container>
                                        <ng-container *ngIf="row?.actionByType === 3">
                                            ({{ 'CONNECTORTYPE.' + row?.connectorType | translate }})
                                        </ng-container>
                                    </span>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="action">
                                <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
                                    <span [innerHtml]="'DATATABLE.COLUMN.UNSUBSCRIBE.ACTIONTYPE.TITLE' | translate" (click)="sort()"></span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <span>
                                        {{ 'CONTACTACTIONTYPE.' + row?.actionType | translate }}
                                    </span>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="created">
                                <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
                                    <span [innerHtml]="'DATATABLE.COLUMN.UNSUBSCRIBE.CREATED.TITLE' | translate" (click)="sort()"></span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <span>{{ row?.created | amLocale: locale | amDateFormat: 'L LT' }}</span>
                                </ng-template>
                            </ngx-datatable-column>
                            <!-- Custom footer -->
                            <ngx-datatable-footer>
                                <ng-template
                                    ngx-datatable-footer-template
                                    let-rowCount="rowCount"
                                    let-pageSize="pageSize"
                                    let-curPage="curPage"
                                    let-isVisible="isVisible">
                                        <div class="pl-2 pt-2">
                                            <span>
                                                {{ rowCount }} {{ ((rowCount === 1) ? ('DATATABLE.FOOTER.LOG.SINGLE.LABEL' | translate) : ('DATATABLE.FOOTER.LOG.MULTIPLE.LABEL' | translate)) }}
                                            </span>
                                        </div>
                                        <datatable-pager
                                            [pagerLeftArrowIcon]="'datatable-icon-left'"
                                            [pagerRightArrowIcon]="'datatable-icon-right'"
                                            [pagerPreviousIcon]="'datatable-icon-prev'"
                                            [pagerNextIcon]="'datatable-icon-skip'"
                                            [page]="curPage"
                                            [size]="pageSize"
                                            [count]="rowCount"
                                            [hidden]="!((rowCount / pageSize) > 1)"
                                            (change)="tableLog.onFooterPage($event)">
                                        </datatable-pager>
                                </ng-template>
                            </ngx-datatable-footer>
                        </ngx-datatable>
                    </div>

                </div>
            </tab>
            <!-- Custom fields -->
            <tab [heading]="'ROUTES.ADDRESSBOOK.MYCONTACTS.CONTACT.CUSTOMFIELDS.TITLE' | translate">
                <div *ngIf="customFields && customFields.length > 0" class="row mt-4">
                    <div class="col-lg-6 mb-2" *ngFor="let field of customFields">
                        <div *ngIf="field.customFieldType !== customFieldTypes['SmartField']" class="form-group row align-items-center">
                            <div class="col-3">
                                <label>{{ getCustomFieldName(field) }}</label>
                            </div>
                            <div class="col-8">
                                <div *ngIf="field.customFieldType === customFieldTypes['FreeText']">
                                    <div class="input-group with-focus" *ngIf="field.freeTextFormat === freeTextFormats['Text']">
                                        <input class="form-control" type="text" [placeholder]="getCustomFieldName(field)" [name]="field.id" [(ngModel)]="field.textValue"/>
                                    </div>
                                    <div class="input-group with-focus" *ngIf="field.freeTextFormat === freeTextFormats['Number']">
                                        <input class="form-control" type="number" [placeholder]="getCustomFieldName(field)" [name]="field.id" [(ngModel)]="field.numberValue"/>
                                    </div>
                                    <div class="input-group with-focus" *ngIf="field.freeTextFormat === freeTextFormats['Date']">
                                        <p-calendar
                                            class="form-control"
                                            inputStyleClass="form-control"
                                            [name]="field.id"
                                            [(ngModel)]="field.dateTimeValue"
                                            [dateFormat]="calendarLocales.calendarDateFormat"
                                            [firstDayOfWeek]="calendarLocales.calendarFirstDayOfWeek"
                                            [placeholder]="calendarLocales.calendarDateFormat"
                                            showIcon="true"
                                            appendTo="body"
                                            baseZIndex="100"
                                        ></p-calendar>
                                    </div>
                                    <div class="input-group with-focus" *ngIf="field.freeTextFormat === freeTextFormats['Time']">
                                        <p-calendar
                                            class="form-control"
                                            inputStyleClass="form-control"
                                            [name]="field.id"
                                            [(ngModel)]="field.textValue"
                                            [hourFormat]="calendarLocales.calendarHourFormat"
                                            [placeholder]="calendarLocales.calendarHourPlaceholder"
                                            hideOnDateTimeSelect="false"
                                            timeOnly="true"
                                            showIcon="true"
                                            appendTo="body"
                                            baseZIndex="100"
                                        ></p-calendar>
                                    </div>
                                    <div class="input-group with-focus" *ngIf="field.freeTextFormat === freeTextFormats['CountryCode']">
                                        <ngx-select
                                            class="form-control select-control"
                                            [allowClear]="true"
                                            [placeholder]="getCustomFieldName(field)"
                                            [items]="itemsCountries"
                                            [(ngModel)]="field.textValue"
                                            [name]="field.id">
                                        </ngx-select>
                                    </div>
                                </div>
                                <div *ngIf="field.customFieldType === customFieldTypes['SingleSelect']">
                                    <div class="input-group with-focus">
                                        <ngx-select
                                            class="form-control select-control"
                                            [allowClear]="true"
                                            [placeholder]="getCustomFieldName(field)"
                                            [items]="field.availableCustomFieldOptions | customFieldOptions"
                                            (select)="onSelectCustomOption($event, field)"
                                            (remove)="onRemoveCustomOption(field)"
                                            [ngModel]="field.contactCustomFieldOptions[0]?.id"
                                            [name]="field.id">
                                        </ngx-select>
                                    </div>
                                </div>
                                <div *ngIf="field.customFieldType === customFieldTypes['MultipleSelect']">
                                    <p-multiSelect
                                        [options]="field.availableCustomFieldOptions | customFieldOptions"
                                        optionLabel="text"
                                        [(ngModel)]="field.selectedMultiOptions"
                                        (onChange)="onSelectMultiOptions($event, field)"
                                        [defaultLabel]="getCustomFieldName(field)"
                                        [name]="field.id"
                                        styleClass="p-multiselect-custom">
                                    </p-multiSelect>
                                </div>
                                <div *ngIf="field.customFieldType === customFieldTypes['Boolean']">
                                    <div class="input-group with-focus">
                                        <label class="switch pl-3">
                                            <input class="form-control" type="checkbox" [(ngModel)]="field.booleanValue" [name]="field.id" />
                                            <span></span>
                                        </label>
                                    </div>
                                </div>
                                <div *ngIf="field.customFieldType === customFieldTypes['SingleSelectUser']">
                                    <div class="input-group with-focus">
                                        <ngx-select
                                            class="form-control select-control"
                                            [allowClear]="true"
                                            [placeholder]="getCustomFieldName(field)"
                                            [items]="usersForDropdown"
                                            (select)="onSelectSingleUser($event, field)"
                                            (remove)="onRemoveSingleUser(field)"
                                            [ngModel]="field.contactCustomFieldUsers[0]?.userId"
                                            [name]="field.id">
                                        </ngx-select>
                                    </div>
                                </div>
                                <div *ngIf="field.customFieldType === customFieldTypes['MultiSelectUser']">
                                    <p-multiSelect
                                        [options]="usersForDropdown"
                                        optionLabel="text"
                                        [(ngModel)]="field.selectedMultiUser"
                                        (onChange)="onSelectMultiUser($event, field)"
                                        [defaultLabel]="getCustomFieldName(field)"
                                        [name]="field.id"
                                        styleClass="p-multiselect-custom">
                                    </p-multiSelect>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <!-- Tags -->
            <tab *ngIf="!this.callFromAddInvitee" [heading]="'ROUTES.ADDRESSBOOK.MYCONTACTS.CONTACT.TAGS.TITLE' | translate">
                <div class="row mt-4">
                    <div class="col-12 mb-2">
                        <tag-input class="form-control tags-list"
                            [placeholder]="selectedContactTags.length !== allContactTags.length ? ('ROUTES.ADDRESSBOOK.MYCONTACTS.CONTACT.TAGS.INPUT.PLACEHOLDER' | translate) : ''"
                            [secondaryPlaceholder]="selectedContactTags.length !== allContactTags.length ? ('ROUTES.ADDRESSBOOK.MYCONTACTS.CONTACT.TAGS.INPUT.PLACEHOLDER' | translate) : ''"
                            [(ngModel)]="selectedContactTags"
                            [ngModelOptions]="{standalone: true}"
                            [onlyFromAutocomplete]="true"
                            theme="bootstrap"
                            [animationDuration]="{enter: '0ms', leave: '0ms'}"
                            [clearOnBlur]="true"
                            (onRemove)="removeTag($event)">
                            <tag-input-dropdown [zIndex]="1100" [dynamicUpdate]="false" [appendToBody]="false" [showDropdownIfEmpty]="true" [autocompleteItems]="contactTagsForAutocomplete"></tag-input-dropdown>
                        </tag-input>
                    </div>
                </div>
            </tab>
    </tabset>
</form>
